import { render, staticRenderFns } from "./LayoutView.vue?vue&type=template&id=b849a290&scoped=true"
import script from "./LayoutView.vue?vue&type=script&lang=js"
export * from "./LayoutView.vue?vue&type=script&lang=js"
import style0 from "./LayoutView.vue?vue&type=style&index=0&id=b849a290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b849a290",
  null
  
)

export default component.exports